// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: 'Suelta aquí los archivos: PDF, fotos, Excel, CSV o Word',
  waiting: 'El envío espera a que se suban los archivos.',
  // A message sent while New chat is starting waits for the new chat (QA90).
  starting: 'Un momento: el nuevo chat se está iniciando y tu mensaje se enviará allí.',
  // A message that waits for the person to deal with a file that can't go with it (QA121).
  blocked: {
    refused: 'Elimina el archivo que no se puede enviar y luego envía tu mensaje.',
    failed: 'Vuelve a intentar subir el archivo o elimínalo, y luego envía tu mensaje.',
  },
  // A PDF's pages on its tile (B37): "PDF · 1.2 MB · 4 pages".
  pages_one: '{{count}} página',
  pages_other: '{{count}} páginas',
  problems: {
    type: 'Este tipo de archivo no se puede enviar. Envía un PDF, una foto (JPG, PNG o HEIC) o un archivo de Excel, CSV o Word.',
    size: 'Supera los 20 MB. Un archivo puede pesar hasta 20 MB.',
    empty: 'Este archivo está vacío.',
    count: 'Máximo 10 archivos por mensaje.',
    upload: 'La subida se interrumpió. Inténtalo de nuevo.',
  },
};
